export default __webpack_public_path__ + "747948be7e403a19553c8d2881112596.png";